module.exports = __webpack_public_path__ + "img/video.e482042d.svg";